class Type {

	public static UNCONTACTED = new Type(1, 1, "Uncontacted", "#DDE7E8", "#05393F");
	public static ATTEMPTED_CONTACT = new Type(2, 2, "Attempted Contact", "#FFDA90", "#532708");
	public static NURTURING = new Type(3, 3, "Nurturing", "#FDA61A", "#532708");
	public static DEAD = new Type(4, 4, "Dead", "#B0BEC5", "#05393F");
	public static UNDER_CONTRACT = new Type(5, 5, "Under Contract", "#FA6800", "#532708");
	public static CLOSED = new Type(6, 6, "Closed", "#36747B", "#CAF5F9");

	private constructor(
		public readonly id: number,
		public readonly stage: number,
		public readonly label: string,
		public readonly color: string,
		public readonly fontColor: string,
	) {
	}

	public get uncontacted() {
		return this === Type.UNCONTACTED;
	}

	public get attemptedContact() {
		return this === Type.ATTEMPTED_CONTACT;
	}

	public get nurturing() {
		return this === Type.NURTURING;
	}

	public get dead() {
		return this === Type.DEAD;
	}

	public get underContract() {
		return this === Type.UNDER_CONTRACT;
	}

	public get closed() {
		return this === Type.CLOSED;
	}

	public static get default(): Type {
		return this.UNCONTACTED;
	}

	public static values(): Type[] {
		return Object.values(Type);
	}

	public static getById(id?: number) {
		return this.values().find(value => value.id === id);
	}

	public static getByLabel(label: string) {
		return this.values().find(value => value.label.toLowerCase() === label.toLowerCase());
	}

	public static getByIdOrDefault(id?: number): Type {
		return this.getById(id) || this.default;
	}
}

export { Type as LeadPipelineType };